import { millisecondsInSecond } from 'date-fns';

import { appStore } from '@kaltura-ott/tvpil-shared';

import { ContextType, ErrorContextPropsValue } from 'context/error/types';
import networkService from 'services/networkService';

import { getConnectionRestoredError } from './getConnectionRestoredError';

let interval: NodeJS.Timer | undefined;

export function retryConnection(initialErrorParams: ErrorContextPropsValue, errorScreenContext: ContextType) {
  const { checkInterval } = appStore.getConnectivityConfiguration();
  let checkIntervalInSeconds = checkInterval / millisecondsInSecond;
  let attempts = networkService.retryCount;

  // clear previous timer if it exists
  if (interval) {
    clearInterval(interval);
  }

  interval = setInterval(async () => {
    checkIntervalInSeconds -= 1;

    errorScreenContext.setError({
      ...initialErrorParams,
      checkConnectionTimer: checkIntervalInSeconds,
      timerInterval: interval,
    });

    if (checkIntervalInSeconds === 0) {
      const isConnectionRestored = await networkService.isNetworkConnection();

      if (isConnectionRestored) {
        clearInterval(interval);
        recoveryConnection(initialErrorParams, errorScreenContext);

        return;
      }

      if (attempts && attempts !== 1) {
        // go to next attempt if there is one
        checkIntervalInSeconds = checkInterval / millisecondsInSecond;
        attempts -= 1;

        return;
      }

      // set Error with Manual Retry button
      clearInterval(interval);
      errorScreenContext.setError(initialErrorParams);
    }
  }, millisecondsInSecond);
}
export function recoveryConnection(inititalErrorParams: ErrorContextPropsValue, errorScreenContext: ContextType) {
  const { recoveryDelay } = appStore.getConnectivityConfiguration();
  let recoveryDelayInSeconds = recoveryDelay / millisecondsInSecond;
  const connectionRestoredParams = getConnectionRestoredError(inititalErrorParams, recoveryDelayInSeconds);

  const autoRetryInterval = setInterval(async () => {
    recoveryDelayInSeconds -= 1;

    errorScreenContext.setError({
      ...connectionRestoredParams,
      restartRetryConnection: async () => {
        if (!(await networkService.isNetworkConnection())) {
          retryConnection(inititalErrorParams, errorScreenContext);
        }
      },
      autoRetryTimer: recoveryDelayInSeconds,
      timerInterval: autoRetryInterval,
    });

    if (recoveryDelayInSeconds === 0) {
      const isConnectionRestored = await networkService.isNetworkConnection();
      clearInterval(autoRetryInterval);

      if (isConnectionRestored) {
        errorScreenContext.autoRetry({
          autoRetryCallback: connectionRestoredParams.retryButton?.onRetry,
          isTvpilError: connectionRestoredParams.isErrorFromTvpil,
        });
        // if connection lost again
      } else {
        retryConnection(inititalErrorParams, errorScreenContext);
      }
    }
  }, millisecondsInSecond);
}
